'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deviceDetection = require('../utils/device-detection');

var _desktop = require('./desktop');

var _desktop2 = _interopRequireDefault(_desktop);

var _ios = require('./ios');

var _ios2 = _interopRequireDefault(_ios);

var _ui = require('../constants/events/ui');

var _ui2 = _interopRequireDefault(_ui);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FullScreenManager = function () {
  function FullScreenManager(_ref) {
    var eventEmitter = _ref.eventEmitter,
        engine = _ref.engine,
        ui = _ref.ui;

    _classCallCheck(this, FullScreenManager);

    this._eventEmitter = eventEmitter;

    this._onChange = this._onChange.bind(this);

    if (_deviceDetection.iPhone || _deviceDetection.iPod || _deviceDetection.iPad) {
      this._helper = new _ios2.default(engine.getNode(), this._onChange);
    } else {
      this._helper = new _desktop2.default(ui.view.getNode(), this._onChange);
    }

    this._bindEvents();
  }

  _createClass(FullScreenManager, [{
    key: '_onChange',
    value: function _onChange() {
      this._eventEmitter.emit(_ui2.default.FULLSCREEN_STATUS_CHANGED, this._helper.isInFullScreen);
    }
  }, {
    key: '_bindEvents',
    value: function _bindEvents() {
      this._eventEmitter.on(_ui2.default.FULLSCREEN_ENTER_TRIGGERED, this.enterFullScreen, this);
      this._eventEmitter.on(_ui2.default.FULLSCREEN_EXIT_TRIGGERED, this.exitFullScreen, this);
    }
  }, {
    key: '_unbindEvents',
    value: function _unbindEvents() {
      this._eventEmitter.off(_ui2.default.FULLSCREEN_ENTER_TRIGGERED, this.enterFullScreen, this);
      this._eventEmitter.off(_ui2.default.FULLSCREEN_EXIT_TRIGGERED, this.exitFullScreen, this);
    }
  }, {
    key: 'enterFullScreen',
    value: function enterFullScreen() {
      this._helper.request();
    }
  }, {
    key: 'exitFullScreen',
    value: function exitFullScreen() {
      this._helper.exit();
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      this._unbindEvents();

      this._helper.destroy();
    }
  }, {
    key: 'isInFullScreen',
    get: function get() {
      return this._helper.isInFullScreen;
    }
  }]);

  return FullScreenManager;
}();

exports.default = FullScreenManager;
//# sourceMappingURL=full-screen.js.map



//////////////////
// WEBPACK FOOTER
// ./~/video-player/dist/src/full-screen/full-screen.js
// module id = 1692
// module chunks = 1 2 3